




import { Component, Vue, Watch } from "vue-property-decorator";

import {
  openDirectoryProductModal,
  parseDirectoryProductId
} from "./utils/openDirectoryProduct";

@Component
export default class ProductDirectoryEntityProxy extends Vue {
  modal: any = null;
  closingSilently = false;

  mounted() {
    this.onParamsChange();
  }

  @Watch("$route.params")
  onParamsChange() {
    this.closeModalSilently();

    const id = parseDirectoryProductId(this.$route.params.id);
    if (id == null) {
      return;
    }

    this.modal = openDirectoryProductModal(this, id, {
      parent: this,
      onClose: () => this.handleModalClosed()
    });
  }

  closeModalSilently() {
    if (!this.modal) {
      return;
    }
    this.closingSilently = true;
    this.modal.close();
    this.modal = null;
  }

  goToDirectory() {
    if (this.$route.name === "product-directory") {
      return;
    }
    // query (фильтр списка) сохраняется при возврате
    this.$router.push({
      name: "product-directory",
      query: this.$route.query
    });
  }

  handleModalClosed() {
    if (this.closingSilently) {
      this.closingSilently = false;
      return;
    }
    this.modal = null;
    this.goToDirectory();
  }

  close() {
    this.closeModalSilently();
    this.goToDirectory();
  }

  beforeDestroy() {
    this.closeModalSilently();
  }
}
